<div class="titulo_seccion">
    {{ 'contacto.titulo' | translate }}
</div>
<p>
  contacto works!
</p>
<!--
<app-tabla-principal></app-tabla-principal>
-->
